import { mxCellRenderer } from 'mxgraph-js';
import HCLTreeMxCellRenderer from './HCLTreeMxCellRenderer';
import GateTypes from '../HCLTreeNode/HCLTreeVertexValue/GateTypes';
import NANDGateVertexShape from '../HCLTreeNode/FaultTreeNode/GateNode/NANDGateNode/NANDGateVertexShape';
import ANDGateVertexShape from '../HCLTreeNode/FaultTreeNode/GateNode/ANDGateNode/ANDGateVertexShape';
import ORGateVertexShape from '../HCLTreeNode/FaultTreeNode/GateNode/ORGateNode/ORGateVertexShape';
import NORGateVertexShape from '../HCLTreeNode/FaultTreeNode/GateNode/NORGateNode/NORGateVertexShape';
import NOTGateVertexShape from '../HCLTreeNode/FaultTreeNode/GateNode/NOTGateNode/NOTGateVertexShape';
import ATLEASTGateVertexShape from '../HCLTreeNode/FaultTreeNode/GateNode/ATLEASTGateNode/ATLEASTGateVertexShape';
import BasicEventVertexDetailedShape from '../HCLCellShape/FaultTree/BasicEvent/BasicEventVertexDetailedShape';
import BasicEventVertexDefaultShape from '../HCLCellShape/FaultTree/BasicEvent/BasicEventVertexDefaultShape';
import HouseEventVertexDefaultShape from "../HCLCellShape/FaultTree/HouseEvent/HouseEventVertexDefaultShape";
import HouseEventVertexDetailedShape from "../HCLCellShape/FaultTree/HouseEvent/HouseEventVertexDetailedShape";
import TransferGateVertexDefaultShape from "../HCLCellShape/TransferGate/TransferGateVertexDefaultShape";
import TransferGateVertexDetailedShape from "../HCLCellShape/TransferGate/TransferGateVertexDetailedShape";

class FaultTreeMxCellRenderer extends HCLTreeMxCellRenderer {
  registerShapes(): void {
    mxCellRenderer.registerShape(BasicEventVertexDefaultShape.typeString, BasicEventVertexDefaultShape);
    mxCellRenderer.registerShape(BasicEventVertexDetailedShape.typeString, BasicEventVertexDetailedShape);
    mxCellRenderer.registerShape(HouseEventVertexDefaultShape.typeString, HouseEventVertexDefaultShape);
    mxCellRenderer.registerShape(HouseEventVertexDetailedShape.typeString, HouseEventVertexDetailedShape);
    mxCellRenderer.registerShape(TransferGateVertexDefaultShape.typeString, TransferGateVertexDefaultShape);
    mxCellRenderer.registerShape(TransferGateVertexDetailedShape.typeString, TransferGateVertexDetailedShape);
    mxCellRenderer.registerShape(GateTypes.NAND, NANDGateVertexShape);
    mxCellRenderer.registerShape(GateTypes.AND, ANDGateVertexShape);
    mxCellRenderer.registerShape(GateTypes.OR, ORGateVertexShape);
    mxCellRenderer.registerShape(GateTypes.NOR, NORGateVertexShape);
    mxCellRenderer.registerShape(GateTypes.NOT, NOTGateVertexShape);
    mxCellRenderer.registerShape(GateTypes.AT_LEAST, ATLEASTGateVertexShape);
  }
}

export default FaultTreeMxCellRenderer;
